import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgentService {

 
  constructor(public apiService: ApiService,) { }

  addAgent(body: any): Observable<any> {
    return this.apiService.post('companyagent/addcompanyagentmanufactrer', body );
  }
  importAgent(body: any): Observable<any> {
    return this.apiService.post('companyagent/importCompanyAgentmanufacturer', body );
  }
  editAgent(body: any, param: any): Observable<any> {
    // console.log(param)
    return this.apiService.put(`companyagent/updatecompanyagentdetails`, param, body);
  }

  getAllAgent(body: any): Observable<any> {
    // return this.apiService.get(`companyagent/getcompanyagentmanufacturer/${param}`);
    return this.apiService.post('companyagent/getcompanyagentmanufacturerBystatusid', body);

  }
  downloadFile(body: any): Observable<any> {
    return this.apiService.post(`file/downloadFile`, body);
  }
  downloadFileByUrl({
    url,
    body,
  }: {
    url: string;
    body: any;
  }): Observable<any> {
    return this.apiService.post(url, body);
  }
  inactiveagents(body: any, param: any): Observable<any> {
    // console.log(param)
    return this.apiService.put(`companyagent/inActivateAgentandmanufacturer`, param, body);
  }
  activateagents(body: any, param: any): Observable<any> {
    // console.log(param)
    return this.apiService.put(`companyagent/activateAgentandmanufacturer`, param, body);
  }
  getAgentsByStatusId(body: any): Observable<any> {
    return this.apiService.post('companyagent/getcompanyagentmanufacturerBystatusid', body);
  }
}
